const columns = () => {
  return [
    {
      title: '名称',
      name: 'name',
      searchItem: {},
    },
    {
      title: '应用服务名称',
      name: 'name',
      tableItem: {
        width: 230
      },
    },
    {
      title: '编号',
      name: 'code',
      searchItem: {},
      tableItem: {
        width: 180
      }
    },
    {
      title: '所属组织',
      name: 'orgName',
      tableItem: {
        width: 200
      },
    },
    {
      title: '来源',
      name: 'sourceType',
      searchItem: {type: 'select'},
      tableItem: {
        width: 200
      },
      dict: [
        {code: 0, codeName: '统一平台'},
        {code: 1, codeName: '第三方系统'}
      ]
    },
    {
      title: '状态',
      name: 'status',
      tableItem: {
        width: 100
      },
      searchItem: {type: 'select'},
      dict: [
        {code: 0, codeName: '禁用'},
        {code: 1, codeName: '启用'}
      ]
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'applicationManage/list',
    ...api
  }
}

const applicationInfo = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default applicationInfo
